import Immutable from 'immutable'

// ------------------------------------
// Constants
// ------------------------------------
export const FINISH_LOADING = 'inf/meta/FINISH_LOADING'
export const UPDATE_ACTIVITY = 'inf/meta/UPDATE_ACTIVITY'

export const constants = {
  FINISH_LOADING,
  UPDATE_ACTIVITY,
}

// ------------------------------------
// Actions
// ------------------------------------
export const loaded = () => ({
  type: FINISH_LOADING,
})

export const updateActivity = time => ({
  payload: { time },
  type: UPDATE_ACTIVITY,
})

export const actions = {
  loaded,
  updateActivity,
}

// ------------------------------------
// Reducer
// ------------------------------------
export const initialState = Immutable.fromJS({
  lastActivity: null,
  loading: true,
})

export default function reducer(state = initialState, { payload, type }) {
  switch (type) {
    case FINISH_LOADING:
      return state.set('loading', false)

    case UPDATE_ACTIVITY:
      return state.set('lastActivity', payload.time)

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/redux/modules/meta.js